/**
 * app/App.tsx — Raíz de la aplicación CELMAXX POS
 */

import { useEffect, useRef } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { QueryProvider } from './providers/QueryProvider'
import { AuthProvider } from './providers/AuthProvider'
import { SentryProvider } from './providers/SentryProvider'
import { Router } from './Router'
import { initDB } from '@lib/dexie/schema'
import { startSyncWorker } from '@lib/outbox/outbox'
import { DataSyncManager } from '@lib/sync/DataSyncManager'
import { EnvironmentProvider } from '@lib/env/useEnvironment'
import { EnvironmentBadge, EnvironmentGuard } from '@lib/env/EnvironmentBadge'
import { AutoActualizar } from './AutoActualizar'

export default function App() {
  const initialized = useRef(false)

  useEffect(() => {
    if (initialized.current) return
    initialized.current = true

    // Inicializar IndexedDB
    initDB().catch(err => {
      console.error('[App] Error iniciando Dexie:', err)
    })

    // Iniciar worker de sync del outbox
    const stopSync = startSyncWorker()

    return () => {
      stopSync()
    }
  }, [])

  return (
    <SentryProvider>
      <QueryProvider>
        <BrowserRouter>
          <AuthProvider>
            <EnvironmentProvider>
              <EnvironmentGuard>
                <DataSyncManager />
                <Router />
              </EnvironmentGuard>
              <EnvironmentBadge />
              <AutoActualizar />
            </EnvironmentProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryProvider>
    </SentryProvider>
  )
}
